import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MessageService } from '../../../../../core';

import { Subscription } from 'rxjs';
import { ProdutividadeFilter, ProdutividadeViewProps } from '../../adapters';
import { ProdutividadeViewService } from '../../services';
import { ProdutividadeClassificacoesKPIWidgetComponent } from '../../widgets/components/classificacoes';
import { RepresentanteProdutividadeWidgetComponent } from '../../../../pessoa/representante/widgets/produtividade';
import { RepresentanteModalidadeComercialFaturamentoWidgetComponent } from '../../../../pessoa/representante/widgets/modalidades-comerciais/faturamento';
import { RepresentanteKPIFilter } from '../../../../pessoa/representante/kpis/adapters';

@Component({
    selector: 'sgt-produtividade-main-view',
    templateUrl: './produtividade-main-view.component.html',
    styleUrls: ['./produtividade-main-view.component.less']
})
export class ProdutividadeMainViewComponent implements OnInit, OnDestroy {
    /** Evento para carregar a view */
    private loadSub$: Subscription;

    /** Widget das classificações */
    @ViewChild('classificacoesWidget') classificacoesWidget: ProdutividadeClassificacoesKPIWidgetComponent;
    /** Widget dos representantes */
    @ViewChild('representantesWidget') representantesWidget: RepresentanteProdutividadeWidgetComponent;
    /** Widget dos KPIs de faturamento das modalidades comerciais */
    @ViewChild('modalidadesComerciaisFaturamentoWidget') modalidadesComerciaisFaturamentoWidget: RepresentanteModalidadeComercialFaturamentoWidgetComponent;

    constructor(private messageService: MessageService,
                private produtividadeViewService: ProdutividadeViewService) { }

    ngOnInit(): void {
        this.initSubscriptions();
    }

    /** Inicia as subscriptions nos eventos da view */
    private initSubscriptions() {
        // Load
        this.loadSub$ = this.produtividadeViewService.load$.subscribe(filter => this.load(filter));
    }

    /** Carrega o dash */
    private load(filter: ProdutividadeFilter) {
        try {
            // Classificações
            this.classificacoesWidget?.load(filter);
            // Representantes
            this.representantesWidget?.load(new RepresentanteKPIFilter({
                ...filter
            }));
            // Modalidades Comerciais
            this.modalidadesComerciaisFaturamentoWidget?.load(new RepresentanteKPIFilter({
                ...filter
            }));
        } catch (error) {
            this.messageService.error('Tente atualizar a página e se o erro persistir entre em contato com o suporte', `Erro ao carregar os KPI's de Produtividade Mensais`, error);
        }
    }

    /** Realiza os unsubscribes nos eventos da view */
    private destroySubscriptions() {
        // Load
        this.loadSub$.unsubscribe();
    }

    ngOnDestroy(): void {
        this.destroySubscriptions();
    }
}
